import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import IconifyIcon from '@core/components/iconify-icon/IconifyIcon.vue'
import ErrorAlert from '@core/components/error-alert/ErrorAlert.vue'
import Ripple from 'vue-ripple-directive'

Ripple.color = 'rgba(255, 255, 255, 0.15)'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(IconifyIcon.name, IconifyIcon)
Vue.component(ErrorAlert.name, ErrorAlert)
Vue.directive('ripple', Ripple)
